import React, { Component } from 'react';
import {
	Button,
	Media
} from 'reactstrap';
import {I18n} from '../../../I18n/components/createCompany';
import './step3.css';
import spinner from '../../../assets/images/spinner.gif';

export default class Step3 extends Component {
	constructor(props) {
		super(props);
		this.state = {
			savedToCloud: props.getStore().savedToCloud
		};
	}

	onSave = () => {
		return event => {
			event.preventDefault();
			event.stopPropagation();
			this.props.jumpToStep(3);
			this.props.onSave();
		};
	};

	render() {
		const {lang} = this.props;
		return (
			<div className="step step4 mt-5">
				<div className="row justify-content-md-center">
					<div className="col-lg-8">
						<form id="Form" className="form-horizontal">
							<div className="form-group">
								<label className="col-md-12 control-label">
									{
										(this.state.savedToCloud  || this.props.saveStatus)
											?
											<div className="text-center">
												<h4>{I18n[lang].stepThree.thanks}</h4>
												<a className="btn btn-info text-white"  onClick={this.props.onStart}>{I18n[lang].stepThree.start}</a>
											</div>
											:
											<div className="text-center">
												<h4>{I18n[lang].stepThree.registrationEnd}</h4>
												<p className="text-left">
													{I18n[lang].stepThree.text}
												</p>
												<div className="create-company__button-group">
													<Media
														className={this.props.loading ?
															'create-company__spinner' : 'create-company__spinner visually-hidden'}
														object
														src={spinner}
														alt="Generic placeholder image"
													/>
													<Button
														className={this.props.loading ?
															'btn invisible' :
															'btn visible'}
														color="primary"
														onClick={this.onSave()}
													>
														{I18n[lang].stepThree.save}
													</Button>
												</div>
											</div>
									}
								</label>
							</div>
						</form>
					</div>
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/CreateCompany/Step3/Step3.js